module.exports = __webpack_public_path__ + "static/decoration-mobile-e878142db2f6e52b625499986bdc0b77.svg";